import UpdateEmailPage from "./UpdateEmailPage";
export default UpdateEmailPage;
